import domtoimage from 'dom-to-image';
import * as MediaLibrary from 'expo-media-library';
import { RefObject } from 'react';
import { Platform } from 'react-native';
import { captureRef } from 'react-native-view-shot';

const takeCapture = async (
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	viewRef: RefObject<any>,
	onSuccess?: (uri?: string) => void,
	onFail?: () => void,
): Promise<boolean> => {
	try {
		if (Platform.OS === 'web') {
			// https://github.com/tsayen/dom-to-image
			// https://github.com/eligrey/FileSaver.js
			const blob = await domtoimage.toBlob(viewRef.current, {
				cacheBust: true,
			});
			const FileSaver = await import('file-saver');
			FileSaver.saveAs(blob, 'image.png');
			if (onSuccess) onSuccess();
		} else {
			// https://docs.expo.io/versions/latest/sdk/captureRef/
			// https://docs.expo.io/versions/latest/sdk/media-library/
			const { granted } = await MediaLibrary.requestPermissionsAsync(
				true,
			);
			if (!granted) return false;
			const result = await captureRef(viewRef, {
				format: 'png',
				quality: 1,
				result: 'tmpfile',
			});
			await MediaLibrary.saveToLibraryAsync(result);
			if (onSuccess) onSuccess(result);
		}

		console.info('took a capture successfully.');
		return true;
	} catch (error) {
		if (onFail) onFail();
		console.warn(error);
		return false;
	}
};

export default takeCapture;
